import type { FaireProductEntity } from "../../entity_types/product";

export const p_rqphvbyymx: FaireProductEntity = {
  token: "p_rqphvbyymx",
  type: "product",
  name: "Thin Taper Candle Holder - Solid Brass",
  brandName: "Bluecorn Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/6eb57cc6c141207691a9a48358c5bca819c36f04b4113fbad36fd0d59145a38a.jpeg",
  priceDollars: 14,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/acf6cdc2a86e80f558e8a27af77c4e5d7ba9a983d15ac3841b7f61d3ecdd2abf.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
